module.exports = __webpack_public_path__ + "media/images/lb/744-174002a28e7aa24e96a14d8739ad546f.svg";